import { render, staticRenderFns } from "./MyPersonalRecords.vue?vue&type=template&id=5a3216a8&scoped=true"
import script from "./MyPersonalRecords.vue?vue&type=script&lang=js"
export * from "./MyPersonalRecords.vue?vue&type=script&lang=js"
import style0 from "./MyPersonalRecords.vue?vue&type=style&index=0&id=5a3216a8&prod&scoped=true&lang=scss"
import style1 from "./MyPersonalRecords.vue?vue&type=style&index=1&id=5a3216a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3216a8",
  null
  
)

export default component.exports